import { render, staticRenderFns } from "./_token.vue?vue&type=template&id=8fc52d9a&"
import script from "./_token.vue?vue&type=script&lang=js&"
export * from "./_token.vue?vue&type=script&lang=js&"
import style0 from "./_token.vue?vue&type=style&index=0&id=8fc52d9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports